import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useLoginCookie from 'shared/model/useLoginCookie'
import formatSendParams from 'shared/lib/formatSendParams'

const useGetMyRanking = () => {
	const [searchParams] = useSearchParams()
	const type = searchParams.get('type') || '1'
	const ranking = searchParams.get('ranking') || ''
	const startScore = searchParams.get('start_score') || ''
	const endScore = searchParams.get('end_score') || ''
	const seriesIdx = searchParams.get('series_idx') || ''
	const managerIdx = searchParams.get('manager_idx') || ''
	const seasonIdx = searchParams.get('season_idx') || ''

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const [loginCookie] = useLoginCookie()

	useEffect(() => {
		const queryParams = {
			type,
			start_score: startScore,
			end_score: endScore,
			series_idx: seriesIdx,
			manager_idx: managerIdx,
			season_idx: seasonIdx,
		}
		if (ranking && ranking !== '0') queryParams.ranking = ranking
		const params = formatSendParams(queryParams)
		loginCookie && fetchRequest('GET', `/ranking?${params}`)
	}, [type, ranking, startScore, endScore, seriesIdx, managerIdx, seasonIdx])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'ranking')
					setAlert('ranking 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'start_score')
					setAlert('시작 점수 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'end_score')
					setAlert('끝 점수 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'series_idx')
					setAlert('대회 시리즈 idx 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'manager_idx')
					setAlert('지점 매니저 idx 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'season_idx')
					setAlert('시즌 idx 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('시즌 데이터가 존재하지 않습니다.')
				else if (fetchResult?.data?.error_code === 2)
					setAlert('대회 시리즈 데이터가 존재하지 않습니다.')
				else if (fetchResult?.data?.error_code === 3)
					setAlert('지점 매니저 데이터가 존재하지 않습니다.')
				else setAlert('데이터를 가져오는데 실패하였습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult]
}

export default useGetMyRanking
